import { projectsConstantsFulfilledConstants, projectsConstantsRejectedConstants, projectsConstantsPendingConstants } from '../actions';

const initialState = {
    data: {},
};

export default function (state = initialState, action) {
    const userId = action.meta;
    switch (action.type) {
        case projectsConstantsPendingConstants.PROJECTS_LOADED_BY_ID:

            return {
                ...state,
                data: {
                    ...state.data,
                    [userId]: {
                        data: [],
                        isLoading: true,
                        error: ''
                    },
                },
            };
        case projectsConstantsFulfilledConstants.PROJECTS_LOADED_BY_ID:
            const { data } = action.payload;

            return {
                ...state,
                data: {
                    ...state.data,
                    [userId]: {
                        data,
                        isLoading: false,
                        error: ''
                    },
                },
            };
        case projectsConstantsRejectedConstants.PROJECTS_LOADED_BY_ID:
            const error = action.payload;

            return {
                ...state,
                data: {
                    ...state.data,
                    [userId]: {
                        ...state.data[userId],
                        isLoading: false,
                        error: error.response ? `${error.response.data.errorMessage || error.response.status + ' ' + error.response.statusText}` :
                            error.message
                    }
                }
            };
        default:
            return state;
    }
}
